import GalleryVM from './gallery-vm';
import Vue from 'vue';
import 'libs/vue-extensions';
export default {
  init(element) {
    console.log('Kadenze.GalleryDemo initialization function called');
    let vm = new Vue(GalleryVM);
    vm.$mount(element);
  }
};

